// extracted by mini-css-extract-plugin
export default {"privacyContainer":"PrivacyPolicy_privacyContainer__KWV9e","privacyTitle":"PrivacyPolicy_privacyTitle__MoDDv","effectiveDate":"PrivacyPolicy_effectiveDate__-9N+a"};